export default "__VITE_ASSET__BqqSY4u0__"